import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useDateInput, { DateInput } from "@/components/form/date-input";
import useToggleInput, { ToggleInput } from "@/components/form/toggle-input";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S09 = (props) => {
    const purchaseDate = useDateInput({
        name: "sale[date][purchase]", label: "Når kjøpte du?",
        ...props,
    })

    const toggle = useToggleInput({
        name: "sale[acquired_never]",
        label: "Kjøpet ble ikke fullført",
        className: "form__radio flex--grow",
        required: false,
        ...props,
    })

    const acquiredDate = useDateInput({
        name: "sale[date][acquired]",
        className: "flex--grow",
        ...props,
        disabled: props?.disabled || toggle.value,
    })

    const radio = useRadioInput({
        name: "sale[is_binding]", label: "Gjelder saken om det er inngått en bindende avtale om kjøp eller ikke?",
        className: "mt-7",
        options: {
            data: [
                { label: "Ja", value: "TRUE" },
                { label: "Nei", value: "FALSE" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om tidsramme for kjøpet">
            <DateInput {...purchaseDate.props} className="mt-7"/>

            <label htmlFor={toggle.props.input.id} data-type="inline" className="mt-7">
                Når overtok du?
            </label>
            <div className="group--flex gg-3">
                <ToggleInput {...toggle.props}/>
                <DateInput {...acquiredDate.props}/>
            </div>
            { toggle.value && <RadioInput {...radio.props}/> }
        </Wrapper>
    );
};

export default S09;
